// Lift hub sign-in tokens out of the URL before anything else runs.
//
// This MUST stay the first import in main.jsx: ES modules evaluate in import
// order, and analytics (services/analytics.js, plus the page_load_time event in
// index.html, which fires on `load`) reports the address. Native sign-ins
// arrive later, by deep link — NativeDeepLinkHandler captures those itself.
// See utils/urlSecrets.js.
import { captureUrlSecrets } from './utils/urlSecrets.js';

captureUrlSecrets();
